module.exports = __webpack_public_path__ + "img/2.7cc2b2ab.png";